module.exports = "<div class=\"js-dropdown-region dropdown-reference\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/referenceEditor.hbs
// module id = 693
// module chunks = 0